import React from 'react';
import styled from 'styled-components';

import { featureEnabled } from 'utils';

import { Button } from '../../Button';
import TogglableButtonWithIcon from '../../Button/TogglableButtonWithIcon';
import { Icon } from '../../Icon';
import Space from '../../Space';
import { Tooltip } from '../../Tooltip';

type QuickActionButtonsProps = {
  listingId: string;
  isFavorite: boolean;
  toggleFavorite: () => void;
  isCoopAgent?: boolean;
};

export const QuickActionButtons: React.FC<QuickActionButtonsProps> = ({
  listingId,
  isFavorite,
  toggleFavorite,
  isCoopAgent,
}) => (
  <StyledButtonsContainer>
    <Space size="middle">
      {
        <Tooltip
          title={
            isCoopAgent ||
            featureEnabled('propertyNotificationsRevampFeature', 1)
              ? ''
              : 'Book a showing on the property to receive updates including registered offers, property announcements, and feedback reminders.'
          }
          placement="left"
        >
          <div>
            <Button
              disabled={
                !isCoopAgent &&
                !featureEnabled('propertyNotificationsRevampFeature', 1)
              }
              shape="circle"
              onClick={() => {
                // Due to the style conflict with Bootstrap styling, a workaround has been implemented.
                // Use `href` prop for 'Button' instead when the listing detail page is refactored to React.
                window.location.href = `#/listing/property_update/${listingId}`;
              }}
            >
              <Icon type="bell" width={15} offset={[0, -1]} />
            </Button>
          </div>
        </Tooltip>
      }
      {/* Temporarily disabled for [SUPRANN-161] */}
      {/* <Button
          shape="circle"
          onClick={() => {
            // Due to the style conflict with Bootstrap styling, a workaround has been implemented.
            // Use `href` prop for 'Button' instead when the listing detail page is refactored to React.
            window.location.href = `#/listing/send/${listingId}`;
          }}
        >
          <Icon type="share" width={15} offset={[0, -1]} />
        </Button> */}
      <TogglableButtonWithIcon
        isToggled={isFavorite}
        shape="circle"
        onClick={() => {
          toggleFavorite();
        }}
        iconType="favorite"
        iconWidth={15}
      />
    </Space>
  </StyledButtonsContainer>
);

const StyledButtonsContainer = styled.div`
  position: absolute;
  pointer-events: auto;
  z-index: 500;
  right: 32px;
  top: 16px;
`;
